import { render, staticRenderFns } from "./BlogFoot.vue?vue&type=template&id=162ad49c&scoped=true&"
import script from "./BlogFoot.vue?vue&type=script&lang=js&"
export * from "./BlogFoot.vue?vue&type=script&lang=js&"
import style0 from "./BlogFoot.vue?vue&type=style&index=0&id=162ad49c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ad49c",
  null
  
)

export default component.exports